import { getPermissions } from "@/api/request/snkd.user";
export default {
  namespaced: true,
  state: {
    permissions: [],
  },
  mutations: {
    setPermissions(state, data) {
      state.permissions = data;
    },
  },
  actions: {
    // 获取权限
    async getPermissions({ commit, state }) {
      const res = await getPermissions();
      if (res.respCode === 0) {
        commit("setPermissions", res.obj.permissions);
        return res.obj.permissions;
      } else {
        return state.permissions;
      }
    },
    // 是否有权限
    async hasPermission({ commit, state }, permission) {
      if (state.permissions.length === 0) {
        //修复dispatch异步问题
        // await dispatch("permission/getPermissions");
        const res = await getPermissions();
        commit("setPermissions", res.obj.permissions);
        return res.obj.permissions.includes(permission);
      } else {
        return state.permissions.includes(permission);
      }
    },
  },
};
